(ns app.front.dashboard.group-configs
  (:require [app.domain.branding.model :as branding-model]
            [app.front.util :refer [for-frag]]
            [app.front.view.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [core.front.admin]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub ::data :-> ::data)


(rf/reg-event-fx ::set-selected-group
  (fn [{:keys [db]} [_ group]]
    (merge {:db (assoc-in db [::data ::selected-group] group)}
           (when-let [id (:id group)]
             {:fx [[:dispatch [::gas/set-group-id id]]
                   [:dispatch [::gas/fetch-management-views id]]]}))))


(rf/reg-sub ::selected-group
  :<- [::data]
  :-> ::selected-group)


(rf/reg-sub ::loading?
  :<- [::data]
  :-> ::loading?)


(defn group-selector [{:keys [on-change] :as opts}]
  [acommon/group-selector (assoc opts
                                 :on-change
                                 (fn [group]
                                   (>evt [::set-selected-group group])
                                   (when on-change
                                     (on-change group))))])


(defn section [tr]
  (let [{:keys [id label uri-path-id] :as selected-group} (<sub [::selected-group])
        views                                             (when id
                                                            (<sub [::gas/management-views id]))
        loading?                                          (<sub [::loading?])]
    [:section {:id "dashboard-group-configs"}
     [:h2 (tr [:dashboard-group-config/heading])]
     [:div.w-full.lg:w-1-2.xxl:w-1-3
      (if loading?
        (cc/select-skeleton {})
        [group-selector {:tr                    tr
                         :initial-selected-item selected-group
                         :title-text            (tr [:dashboard-group-config/select-label])}])]
     (when id
       [:div.border-t.border-solid.border-ui-gray.mt-6.pt-6
        [:h3.mb-0 label]
        [:div.w-full.xl:w-2-3.xxl:w-1-2 {:id "available-config-views"}
         [:ul.flex.flex-row.flex-wrap {:id id}
          (for-frag [[view view-name] views]
            [:li.mr-4.mt-4 {:id (str id "-" (name view))}
             (cc/link {:href (href/branded-href (branding-model/or-default uri-path-id)
                                                view
                                                {:group-id id}
                                                (when-not (gas/group-admin-route? view)
                                                  {:group-id id}))}
                      view-name)])]]])]))
